import styled from 'styled-components';

export const Container = styled.div`
  padding: 80px 50px 20px 130px;

  @media (max-width: ${({ theme }) => theme.gridBreakpoints.sm}) {
    padding: 120px 16px 16px;
  }

  @media (max-width: 1200px) {
    padding: 50px 40px 20px 100px;
  }

  @media (max-width: 400px) {
    padding: 110px 12px 12px;
  }
`;
